import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import { useParams } from "react-router-dom";
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Spinner } from 'reactstrap';
import { IoCashOutline, IoCalendarOutline } from "react-icons/io5";
import { BASE_URL } from '../config';

export default function Dashboard() {
    const { id } = useParams(); // expects ID from the route params
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                const response = await fetch(`${BASE_URL}Specialist_Dashboard?id=${id}`, {
                    headers: {
                        'accept': 'text/plain'
                    }
                });

                const result = await response.json();

                if (result.responseCode === "0000") {
                    setDashboardData(result.specialistDashboardView[0]);
                } else {
                    console.error("API returned error:", result.message);
                }
            } catch (error) {
                console.error("Failed to fetch dashboard data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchDashboardData();
    }, [id]);

    const {
        totalAppointments = 0,
        missed_Appointment = 0,
        connected_Appointment = 0,
        totalPendingAppointments = 0,
        currentDayAppointments = 0,
        CancelledAppointments = 0,
        totalAmount = "0.00",
        totalPendingAmount = "0.00",
        totalPaidAmount = "0.00"
    } = dashboardData || {};

    return (
        <Container fluid className='h-custom py-1'>
            <Header />

            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <Spinner size="lg" />
                </div>
            ) : (

                <Row>
                    <Col xs="6" sm="6" md="6" lg="4" className="mt-3">
                        <Card className='dashboardCard'>
                            <Card.Body className='p-2'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p className='mb-2'>Total Amount</p>
                                        <h4 className='mb-0'>{totalAmount}/- </h4>
                                    </div>
                                    <Card className='shadow-none p-2 bg_light text-dark'>
                                        <IoCashOutline size={35} />
                                    </Card>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs="6" sm="6" md="6" lg="4" className="mt-3">
                        <Card className='dashboardCard'>
                            <Card.Body className='p-2'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p className='mb-2'>Paid Amount</p>
                                        <h4 className='mb-0'>{totalPaidAmount}/- </h4>
                                    </div>
                                    <Card className='shadow-none p-2 bg_light text-dark'>
                                        <IoCashOutline size={35} />
                                    </Card>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs="6" sm="6" md="6" lg="4" className="mt-3">
                        <Card className='dashboardCard'>
                            <Card.Body className='p-2'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p className='mb-2'>Pending Amount</p>
                                        <h4 className='mb-0'>{totalPendingAmount}/- </h4>
                                    </div>
                                    <Card className='shadow-none p-2 bg_light text-dark'>
                                        <IoCashOutline size={35} />
                                    </Card>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs="6" sm="6" md="6" lg="4" className="mt-3">
                        <Card className='dashboardCard'>
                            <Card.Body className='p-2'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p className='mb-2'>Total Appointments</p>
                                        <h4 className='mb-0'>{totalAppointments}</h4>
                                    </div>
                                    <Card className='shadow-none p-2 bg_light text-dark'>
                                        <IoCalendarOutline size={35} />
                                    </Card>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs="6" sm="6" md="6" lg="4" className="mt-3">
                        <Card className='dashboardCard'>
                            <Card.Body className='p-2'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p className='mb-2'>Today Appointments</p>
                                        <h4 className='mb-0'>{currentDayAppointments}</h4>
                                    </div>
                                    <Card className='shadow-none p-2 bg_light text-dark'>
                                        <IoCalendarOutline size={35} />
                                    </Card>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs="6" sm="6" md="6" lg="4" className="mt-3">
                        <Card className='dashboardCard'>
                            <Card.Body className='p-2'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p className='mb-2'>Pending Appointments</p>
                                        <h4 className='mb-0'>{totalPendingAppointments}</h4>
                                    </div>
                                    <Card className='shadow-none p-2 bg_light text-dark'>
                                        <IoCalendarOutline size={35} />
                                    </Card>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs="6" sm="6" md="6" lg="4" className="mt-3">
                        <Card className='dashboardCard'>
                            <Card.Body className='p-2'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p className='mb-2'>Connected Appointments</p>
                                        <h4 className='mb-0'>{connected_Appointment}</h4>
                                    </div>
                                    <Card className='shadow-none p-2 bg_light text-dark'>
                                        <IoCalendarOutline size={35} />
                                    </Card>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs="6" sm="6" md="6" lg="4" className="mt-3">
                        <Card className='dashboardCard'>
                            <Card.Body className='p-2'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p className='mb-2'>Missed Appointments</p>
                                        <h4 className='mb-0'>{missed_Appointment}</h4>
                                    </div>
                                    <Card className='shadow-none p-2 bg_light text-dark'>
                                        <IoCalendarOutline size={35} />
                                    </Card>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* <Col xs="6" sm="6" md="6" lg="4" className="mt-3">
                        <Card className='dashboardCard'>
                            <Card.Body className='p-2'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p className='mb-2'>Cancelled Appointments</p>
                                        <h4 className='mb-0'>{CancelledAppointments}</h4>
                                    </div>
                                    <Card className='shadow-none p-2 bg_light text-dark'>
                                        <IoCalendarOutline size={35} />
                                    </Card>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col> */}
                </Row>
            )}


        </Container>
    );
}
